import { Textarea, TextareaProps } from '@chakra-ui/react'
import { FieldValues, Path } from 'react-hook-form'

import { Inputs } from './models'

interface MyProps<T extends FieldValues, K extends Path<T>>
  extends Inputs.InputData<T, K>,
    TextareaProps {}

export default function <T extends FieldValues, K extends Path<T>>(
  props: MyProps<T, K>,
) {
  const {
    useForm: { register },
    useFormField,
    ...rest
  } = props

  return <Textarea {...register(useFormField)} {...rest} />
}
